module.exports = __webpack_public_path__ + "static/img/Awin1.0851b678.jpeg";